import { ProfilDTO } from "./profil.model.ts";
import { FokontanyDTO } from "@utils/appUtils.ts";

export interface UserPostDTO {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  password: string;
  telephone: string;
  address: string;
  status: "ACTIVE";
  profil: string;
  fokontany: number;
  region: number;
}

export interface UserDTO {
  id: string;
  uuid: string | { value: string };
  userId: any; 
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  telephone: string;
  address: string;
  createdAt?: any;
  profil: ProfilDTO;
  fokontany: FokontanyDTO;
  status?: string;
  region?: {
    id: number;
    name: string;
    code: string;
  };
}

// export interface SearchDTO {
//   firstName: string;
//   lastName: string;
//   email: string;
//   password: string;
// }

export interface Localisation {
  "Code Province": number;
  Province: string;
  "Code Region": number;
  Region: string;
  "Code District": number;
  District: string;
  "Code Commune": number;
  Commune: string;
  Code_fokotany: string | number;
  nom_fokontany: string;
}

export const accessLists = [
  {
    id: "e863d79b-4edc-4fc5-928a-d3246d76e7b7",
    name: "Plaintes",
    description: "Plaintes",
  },
  {
    id: "1b544770-5c21-43be-afd0-78bec23e8cc0",
    name: "Dashboard",
    description: "Dashboard",
  },
  {
    id: "5f82c838-407d-4519-97f2-97cb934860ab",
    name: "Manage users",
    description: "Manage users",
  },
];

export const getPhoneMaxLength = (value?: string | null) => {
  return (value ?? "").startsWith("+261") ? 13 : 10;
};
